module.exports = __webpack_public_path__ + "img/图片10.efc89229.png";